import ScrollProvider from "./ScrollProvider";

export default ScrollProvider;
